import React from "react";
import { Box } from "@mui/material";
import { Business } from "@mui/icons-material";
import { HtmlTooltip, IconText } from "../StyledComponents/styled";
import { ListingIconMetric, ListingMetricValue } from "./styles";

/**
 * Icon + retailer count. Hover lists names AZ.
 * Empty rows show 0 and "No Retailer added yet" (campaigns only in practice).
 */
const RetailerIconCount = ({ names = [] }) => {
    const sortedNames = (Array.isArray(names) ? [...names] : [])
        .filter((name) => typeof name === "string" && name !== "")
        .sort((firstName, secondName) => firstName.localeCompare(secondName));

    const tooltipTitle =
        sortedNames.length === 0 ? (
            "No Retailer added yet"
        ) : (
            <Box component="ul" sx={{ margin: 0, paddingLeft: 2 }}>
                {sortedNames.map((retailerName) => (
                    <li key={retailerName}>{retailerName}</li>
                ))}
            </Box>
        );

    return (
        <HtmlTooltip title={tooltipTitle}>
            <span>
                <ListingIconMetric>
                    {/* Default icon size, same as the campaign and clip metric icons. */}
                    <Business sx={{ color: "#AF3241" }} />
                    <ListingMetricValue>
                        <IconText variant="body2">{sortedNames.length}</IconText>
                    </ListingMetricValue>
                </ListingIconMetric>
            </span>
        </HtmlTooltip>
    );
};

export default RetailerIconCount;
